import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import subs from '@/static/assets/reviews/RyanAllen/subs.vtt';
import poster from '@/static/assets/reviews/RyanAllen/video.jpg';

export const RyanAllen: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Car],
  reviewerName: 'Ryan',
  videoUrl: `${ASSETS_URL}/car/RyanAllen_Car.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
